<template>
    <component
        :is="rendererComponentName"
        :params="params"></component>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {FieldEditorTypes} from '../../../../../../../types/document-viewer/field/modules/editor'

const renderers = {
    base: 'RENDERER_BASE',
    hotkey: 'RENDERER_HOTKEY',
    status: 'RENDERER_STATUS'
}

export default Vue.extend({
    name: 'AgGridCellRendererContainer',
    components: {
        [renderers.base]: () => import(/* webpackChunkName: "renderer_base" */ './components/AgGridCellRendererBase'),
        [renderers.hotkey]: () => import(/* webpackChunkName: "renderer_hotkey" */ './components/AgGridCellRendererHotkey.vue'),
        [renderers.status]: () => import(/* webpackChunkName: "renderer_status" */ './components/AgGridCellRendererStatus.vue')
    },
    computed: {
        ...mapGetters('doc_viewer_metadata', [
            'getFieldMetadata',
            'isTouchedForm'
        ]),

        field() { // FormField
            return this.params.settings || {}
        },

        editor() {
            return this.field.editor || {}
        },

        prop() {
            return this.params.column.colId
        },

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        isNumericField() {
            return this.editor.type === FieldEditorTypes.NUMERIC
        },

        metadata() {
            return this.getFieldMetadata({path: this.field.path, idx: this.lineIdx}) || {}
        },

        rendererComponentName() {
            switch (this.prop) {
            case 'hotkey':
                return renderers.hotkey
            case 'status':
                return renderers.status
            }
            return renderers.base
        }
    },
    created() {
        // console.log(this.params)
    }
})
</script>
